import { render } from "./grid.vue?vue&type=template&id=2dbdde65&scoped=true"
import script from "./grid.vue?vue&type=script&lang=js"
export * from "./grid.vue?vue&type=script&lang=js"

import "./grid.vue?vue&type=style&index=0&id=2dbdde65&lang=css"
import "./grid.vue?vue&type=style&index=1&id=2dbdde65&scoped=true&lang=css"

import exportComponent from "D:\\televaultdist\\hepi_ui_2.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dbdde65"]])

export default __exports__